<template>
  <div class="card">
    <div v-if="logo" class="card-image">
      <img class="logo" :src="logo" :alt="title">
    </div>
    <div class="card-content">
      <div class="header">
        <div v-if="titleLogo" class="title-logo">
          <SvgIcon v-if="isSvg" :source="titleLogo"></SvgIcon>
          <img v-else :src="titleLogo" :alt="title">
        </div>
        <h1>{{ title }}</h1>
      </div>
      <div class="description">
        <div class="cut-text">{{ desc }}</div>
      </div>
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
  import SvgIcon from '@/components/common/svg-icon';

  export default {
    name: 'card',
    components: { SvgIcon },
    props: {
      title: {
        type: String,
        required: false,
        default: '',
      },
      desc: {
        type: String,
        required: false,
        default: '',
      },
      logo: {
        type: String,
        required: false,
        default: '',
      },
      titleLogo: {
        type: String,
        required: false,
        default: '',
      },
      buttonText: {
        type: String,
        required: false,
        default: '',
      },
    },
    data() {
      return {};
    },
    computed: {
      isSvg() {
        return /^<svg/.test(this.titleLogo);
      },
    },
  };

</script>

<style scoped lang="scss">
  .card {
    font-family: inherit;
    display: flex;
    flex-direction: row;
    max-width: 550px;
    background: inherit;
    @include themify {
      border-color: getColor('card-border', 'ihu');
      background-color: getColor('card-bg', 'ihu');
    }

    & > .card-image {
      width: 100%;
      max-width: 30%;
      display: flex;
      overflow: hidden;

      & > img {
        margin: auto 0;
        object-fit: contain;
      }
    }

    & > .card-content {
      @include themify {
        color: getColor('card-main-color', 'ihu');
      }

      margin: 2.125rem;
      display: flex;
      flex-direction: column;
      flex: 1;
      width: auto;

      & > * {
        text-align: left;
        margin-bottom: 1.25rem;

        &:last-child {
          margin-bottom: 0;
        }
      }

      & > .header {
        margin-bottom: 1rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex: 0;

        .title-logo {
          width: 36px;
          height: 36px;
          margin-right: .875rem;
          border-radius: 8px;
          display: flex;
          align-items: center;
        }

        & > h1 {
          font-size: 1.125rem;
          margin: 0;
          letter-spacing: 0.33px;
          white-space: nowrap;
          overflow: hidden;

          @include themify {
            color: getColor('card-header-color', 'ihu');
          }
        }
      }

      & > .description {
        font-size: .875rem;
        line-height: 150%;
        font-weight: normal;
        flex: 1;
        overflow: hidden;

        .cut-text {
          height: 100%;
          width: 100%;
          text-overflow: ellipsis;
          column-width: 300px;
        }
      }
    }
  }
</style>
